<script>
import { Statistic } from '@models'

export default {
    props: {
        type: String,
        filters: Object,
    },
    data () {
        return {
            loading: false,
            stat: null,
        }
    },
    computed: {
        scope () {
            return {
                loading: this.loading,
                stat: this.stat,
            }
        },
    },
    methods: {
        async fetch () {
            try {
                this.loading = true
                this.stat = await Statistic.get(this.type, this.filters.from, this.filters.to)
            } finally {
                this.loading = false
            }
        }
    },
    mounted () {
        this.fetch()
    },
    render () {
        return this.$scopedSlots.default(this.scope)
    },
    watch: {
        filters: {
            deep: true,
            handler () {
                this.fetch()
            },
        },
    },
}
</script>
